var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5.00001C1.66675 4.07954 2.41294 3.33334 3.33341 3.33334H16.6667C17.5872 3.33334 18.3334 4.07954 18.3334 5.00001V15C18.3334 15.9205 17.5872 16.6667 16.6667 16.6667H3.33342C2.41294 16.6667 1.66675 15.9205 1.66675 15V5.00001ZM4.59891 5.00001L10.0001 9.72604L15.4013 5.00001H4.59891ZM16.6667 6.10732L10.5488 11.4605C10.2346 11.7354 9.76552 11.7354 9.45133 11.4605L3.33341 6.10732V15H16.6667V6.10732Z",
    fill: "#768A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.dfe4b859b91506ba4c675b66838ec3a4.svg";
export { ForwardRef as ReactComponent };